import SlidingListItem from './SlidingListItem';

export default SlidingListItem;
